import type { ISODate } from './types';

export function todayInTimezone(timezone: string, date = new Date()): ISODate {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
  const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((part) => part.type === type)?.value;
  return `${get('year')}-${get('month')}-${get('day')}` as ISODate;
}

export function periodStart(date: ISODate): ISODate {
  return `${date.slice(0, 7)}-01` as ISODate;
}

export function isInMonth(date: ISODate, month: ISODate): boolean {
  return date.slice(0, 7) === month.slice(0, 7);
}

export function comparisonRange(today: ISODate): { currentStart: ISODate; currentEnd: ISODate; previousStart: ISODate; previousEnd: ISODate } {
  const [year, month, day] = today.split('-').map(Number);
  const currentStart = `${year}-${String(month).padStart(2, '0')}-01` as ISODate;
  const previousMonthDate = new Date(Date.UTC(year, month - 2, 1));
  const previousYear = previousMonthDate.getUTCFullYear();
  const previousMonth = previousMonthDate.getUTCMonth() + 1;
  const maxPreviousDay = new Date(Date.UTC(previousYear, previousMonth, 0)).getUTCDate();
  const previousEndDay = Math.min(day, maxPreviousDay);
  return {
    currentStart,
    currentEnd: today,
    previousStart: `${previousYear}-${String(previousMonth).padStart(2, '0')}-01` as ISODate,
    previousEnd: `${previousYear}-${String(previousMonth).padStart(2, '0')}-${String(previousEndDay).padStart(2, '0')}` as ISODate
  };
}

export function anchoredDate(year: number, month: number, anchorDay: number): ISODate {
  const last = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return `${year}-${String(month).padStart(2, '0')}-${String(Math.min(anchorDay, last)).padStart(2, '0')}` as ISODate;
}
